export default "__VITE_ASSET__DxuhHmi5__"